<template>
  <div class="activity-container">
    <div class="base-flex base-margin__bottom-10">
      <el-button type="primary" @click="describeSubclusterActivities">{{ $t('customCluster.activity.refresh') }}
      </el-button>
      <el-select
        v-model="typeList"
        :placeholder="$t('customCluster.activity.selectActivityType')"
        class="select-status base-margin__left-10"
        clearable
        collapse-tags
        multiple
        @change="describeSubclusterActivities"
      >
        <el-option
          v-for="item in typeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-select
        v-model="statusList"
        :placeholder="$t('customCluster.activity.selectStatus')"
        class="select-status"
        clearable
        collapse-tags
        multiple
        @change="describeSubclusterActivities"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <el-table ref="expandTable"
              :data="manageData"
              class="activity-table"
              @row-click="handleRowClick">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <!--    实例操作      -->
          <div v-if="scope.row.activityType < SubclusterActivityTypeModifySubcluster"
               class="details">
            <otherOperationsActivity :detailsData="scope.row"/>
          </div>

          <!--    绑定解绑弹性网卡操作      -->
          <div
            v-if="scope.row.activityType === SubclusterActivityTypeAttachNetworkInterface || scope.row.activityType === SubclusterActivityTypeDetachNetworkInterface"
            class="details">
            <networkInterfaceActivity :detailsData="scope.row"/>
          </div>

          <!--    新增弹性网卡操作      -->
          <div v-if="scope.row.activityType === SubclusterActivityTypeCreateNetworkInterface" class="details">
            <createNetworkInterfaceActivity :detailsData="scope.row"/>
          </div>

          <!--    修改子集群信息/设置初始化脚本/修改超线程设置      -->
          <div v-if="scope.row.activityType === SubclusterActivityTypeModifySubcluster ||
          scope.row.activityType === SubclusterActivityTypeSetInstanceUserdata ||
          scope.row.activityType === SubclusterActivityTypeSetTopology || scope.row.activityType === SubclusterActivityTypeModifyInstancesChargeType"
               class="details">
            <editCustomDetailActivity :detailsData="scope.row"/>
          </div>

          <!--    调整实例配置      -->
          <div v-if="scope.row.activityType === SubclusterActivityTypeResetInstanceType" class="details">
            <adjustingExamplesActivity :detailsData="scope.row"/>
          </div>

          <div class="details">
            <div class="base-margin__left-20" @click="getSubclusterActivityDetails(scope.row)">
              <span class="base-color__light_blue base-cursor__pointer">[{{
                  $t('customCluster.activity.viewActivityLog')
                }}]</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('customCluster.activity.activityId')" prop="activityId" width="100"></el-table-column>
      <el-table-column :label="$t('customCluster.activity.userName')">
        <template slot-scope="scope">
          <span>{{ scope.row?.userInfo?.name || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('customCluster.activity.activityType')">
        <template slot-scope="scope">
          <p>{{ processType(scope.row.activityType) }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('customCluster.activity.status')">
        <template slot-scope="scope">
          <p>{{ processStatus(scope.row.activityStatus) }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('customCluster.activity.startTime')">
        <template slot-scope="scope">
          {{ processTime(scope.row.startAt) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('customCluster.activity.endTime')">
        <template slot-scope="scope">
          {{ processTime(scope.row.endAt) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="10"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-dialog
      :title="$t('customCluster.activity.activityDetails')"
      :visible.sync="showDetailInfoVisible"
      width="1000px"
    >
      <div class="base-margin__left-20">
        <p v-for="(item, index) in detailInfo" :key="index" class="base-margin__bottom-5">{{ item }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {postRequest} from '@/common/libs/request';
import {
  SubclusterActivityTypeAttachNetworkInterface,
  SubclusterActivityTypeCreateNetworkInterface,
  SubclusterActivityTypeDetachNetworkInterface,
  SubclusterActivityTypeImportInstances,
  SubclusterActivityTypeModifyInstancesChargeType,
  SubclusterActivityTypeModifyInstancesRenewFlag,
  SubclusterActivityTypeModifySubcluster,
  SubclusterActivityTypeRebootInstances,
  SubclusterActivityTypeResetInstanceType,
  SubclusterActivityTypeRunInstances,
  SubclusterActivityTypeSetInstanceUserdata,
  SubclusterActivityTypeSetTopology,
  SubclusterActivityTypeStartInstances,
  SubclusterActivityTypeStopInstances,
  SubclusterActivityTypeTerminateInstances
} from '@/common/constants';
import otherOperationsActivity from './components/activityInfo/otherOperationsActivity.vue';
import networkInterfaceActivity from './components/activityInfo/networkInterfaceActivity.vue';
import createNetworkInterfaceActivity from './components/activityInfo/createNetworkInterfaceActivity.vue';
import editCustomDetailActivity from './components/activityInfo/editCustomDetailActivity.vue';
import adjustingExamplesActivity from './components/activityInfo/adjustingExamplesActivity.vue';

export default {
  name: 'activity',
  components: {
    otherOperationsActivity,
    networkInterfaceActivity,
    createNetworkInterfaceActivity,
    editCustomDetailActivity,
    adjustingExamplesActivity,
  },
  data() {
    return {
      date: '',
      total: 0,
      searchInput: '',
      currentPage: 1,
      limit: 10,
      manageData: [],
      expands: [],
      showDetailInfoVisible: false,
      detailInfo: '',
      statusOptions: [
        {label: this.$t('customCluster.activity.executing'), value: '1'},
        {label: this.$t('customCluster.activity.success'), value: '2'},
        {label: this.$t('customCluster.activity.partialSuccess'), value: '3'},
        {label: this.$t('customCluster.activity.failed'), value: '4'},
      ],
      typeOptions: [
        {label: this.$t('customCluster.activity.createInstance'), value: SubclusterActivityTypeRunInstances},
        {label: this.$t('customCluster.activity.rebootInstance'), value: SubclusterActivityTypeRebootInstances},
        {label: this.$t('customCluster.activity.stopInstance'), value: SubclusterActivityTypeStopInstances},
        {label: this.$t('customCluster.activity.startInstance'), value: SubclusterActivityTypeStartInstances},
        {label: this.$t('customCluster.activity.terminateInstance'), value: SubclusterActivityTypeTerminateInstances},
        {label: this.$t('customCluster.activity.modifySubcluster'), value: SubclusterActivityTypeModifySubcluster},
        {
          label: this.$t('customCluster.activity.attachNetworkInterface'),
          value: SubclusterActivityTypeAttachNetworkInterface
        },
        {
          label: this.$t('customCluster.activity.createNetworkInterface'),
          value: SubclusterActivityTypeCreateNetworkInterface
        },
        {
          label: this.$t('customCluster.activity.detachNetworkInterface'),
          value: SubclusterActivityTypeDetachNetworkInterface
        },
        {label: this.$t('customCluster.activity.resetInstanceType'), value: SubclusterActivityTypeResetInstanceType},
        {label: this.$t('customCluster.activity.setTopology'), value: SubclusterActivityTypeSetTopology},
        {
          label: this.$t('customCluster.activity.modifyChargeType'),
          value: SubclusterActivityTypeModifyInstancesChargeType
        },
        {label: this.$t('customCluster.activity.setUserdata'), value: SubclusterActivityTypeSetInstanceUserdata},
        {label: this.$t('customCluster.activity.importInstance'), value: SubclusterActivityTypeImportInstances},
        {
          label: this.$t('customCluster.activity.modifyRenewFlag'),
          value: SubclusterActivityTypeModifyInstancesRenewFlag
        },
      ],
      statusList: [],
      typeList: [],
      SubclusterActivityTypeCreateNetworkInterface,
      SubclusterActivityTypeAttachNetworkInterface,
      SubclusterActivityTypeDetachNetworkInterface,
      SubclusterActivityTypeModifySubcluster,
      SubclusterActivityTypeSetInstanceUserdata,
      SubclusterActivityTypeSetTopology,
      SubclusterActivityTypeResetInstanceType,
      SubclusterActivityTypeModifyInstancesChargeType,
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  mounted() {
    this.describeSubclusterActivities();
  },
  methods: {
    // 点击
    handleRowClick(row) {
      row.expanded = !row.expanded;
      this.$refs.expandTable.toggleRowExpansion(row, row.expanded);
    },

    handleSizeChange(limit) {
      if (limit === this.limit) {
        return;
      }
      this.currentPage = 1;
      this.limit = limit;
      this.describeSubclusterActivities();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.describeSubclusterActivities();
    },

    // 获取子集群活动列表
    describeSubclusterActivities() {
      const offset = this.limit * (this.currentPage - 1);
      const data = {
        subclusterId: Number(this.$route.query.id),
        offset,
        limit: this.limit,
        filters: [{
          name: 'type',
          values: this.typeList.map(String),
        }, {
          name: 'status',
          values: this.statusList,
        }],
      };
      postRequest('/api/eda/common/subcluster/getSubclusterActivities', data).then((res) => {
        this.manageData = res.activityInfo || [];
        this.total = res.totalCount || 0;
      });
    },
    processTime(val) {
      if (val === 0) {
        return '-';
      }
      const time = new Date(val * 1000);
      const month = time.getMonth() + 1 < 10 ? `0${time.getMonth() + 1}` : time.getMonth() + 1;
      const day = time.getDate() < 10 ? `0${time.getDate()}` : time.getDate();
      const hours = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours();
      const minutes = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes();
      const seconds = time.getSeconds() < 10 ? `0${time.getSeconds()}` : time.getSeconds();
      return `${time.getFullYear()}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },
    processStatus(val) {
      switch (val) {
        case 1:
          return this.$t('customCluster.activity.executing');
        case 2:
          return this.$t('customCluster.activity.success');
        case 3:
          return this.$t('customCluster.activity.partialSuccess');
        case 4:
          return this.$t('customCluster.activity.failed');
        default:
          return '-';
      }
    },

    filterStatus(val) {
      switch (val) {
        case 1:
          return {
            label: this.$t('customCluster.activity.notExecuted'),
          };
        case 2:
          return {
            label: this.$t('customCluster.activity.executing'),
          };
        case 3:
          return {
            label: this.$t('customCluster.activity.success'),
            value: '[RESULT] successful',
          };
        case 4:
          return {
            label: this.$t('customCluster.activity.failed'),
            value: '[RESULT-FAILED] failed to',
          };
        default:
          return '-';
      }
    },

    processType(val) {
      switch (val) {
        case 1:
          return this.$t('customCluster.activity.createInstance');
        case 2:
          return this.$t('customCluster.activity.terminateInstance');
        case 3:
          return this.$t('customCluster.activity.startInstance');
        case 4:
          return this.$t('customCluster.activity.stopInstance');
        case 5:
          return this.$t('customCluster.activity.rebootInstance');
        case 6:
          return this.$t('customCluster.activity.modifySubcluster');
        case 7:
          return this.$t('customCluster.activity.attachNetworkInterface');
        case 8:
          return this.$t('customCluster.activity.detachNetworkInterface');
        case 9:
          return this.$t('customCluster.activity.setUserdata');
        case 10:
          return this.$t('customCluster.activity.resetInstanceType');
        case 11:
          return this.$t('customCluster.activity.setTopology');
        case 12:
          return this.$t('customCluster.activity.createNetworkInterface');
        case 13:
          return this.$t('customCluster.activity.modifyChargeType');
        case 14:
          return this.$t('customCluster.activity.importInstance');
        case 15:
          return this.$t('customCluster.activity.modifyRenewFlag');
        default:
          return '-';
      }
    },

    // 获取活动详情
    getSubclusterActivityDetails(subclusterActivity) {
      postRequest('/api/eda/common/subcluster/getSubclusterActivityDetails', {
        subclusterActivityId: subclusterActivity.activityId,
        subclusterId: Number(this.$route.query.id),
      }).then((res) => {
        this.detailInfo = '';
        const detailslist = [];
        let activityType = '';
        if (subclusterActivity.activityType === SubclusterActivityTypeAttachNetworkInterface || subclusterActivity.activityType === SubclusterActivityTypeDetachNetworkInterface) {
          if (subclusterActivity.activityType === SubclusterActivityTypeAttachNetworkInterface) {
            activityType = 'attaching';
          } else {
            activityType = 'detaching';
          }


          res.activityInfo.detailData.map((item) => {
            if (item.status === 1 || item.status === 2) {
              detailslist.push(`[INFO] ${activityType} network inteface ${item.networkInterfaceId} to ${item.instanceId}, ${item.cloudRequestId},  ${item.createTime}`);
            } else {
              detailslist.push(
                `[INFO] ${activityType} network inteface ${item.networkInterfaceId} to ${item.instanceId}, ${item.cloudRequestId},  ${item.createTime}`,
                `${this.filterStatus(item.status).value} ${activityType} network inteface ${item.networkInterfaceId} to ${item.instanceId},  ${item.createTime}`,
              );
            }
          });
        }
        this.detailInfo = res?.activityInfo?.details || detailslist;
        this.showDetailInfoVisible = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-container {
  height: 100%;
}

.activity-head {
  height: 32px;
  margin-bottom: 20px;
  display: none;
}

.activity-table {
  height: calc(100% - 120px);

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
}

.pagination {
  padding: 20px 10px;
  background: #fff;
  text-align: right;

  ::v-deep .el-pagination__total {
    float: left;
  }
}

.refresh {
  padding: 0;
  font-size: 20px;
}

.details {
  padding: 0 20px;
}

.select-status {
  width: 240px !important;
  margin-right: 10px;

  ::v-deep .el-input {
    width: 240px !important;
  }
}
</style>
